import axios from "axios";
import jwtDecode from "jwt-decode";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../../../firebaseConfig";

const headers = {
  "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
  "Content-Type": "application/json",
};

export const getToken = async (email) => {
  const payload = {
    OTP: "7777",
    UserName: email,
  };

  const otpHeaders = {
    "Content-Type": "application/json",
    Authorization: "Bearer 1231243123hjvjVJHVvjv",
    DeviceId: "us_web",
    DeviceType: "web",
    Lat: "us_lat",
    Long: "us_long",
  };

  try {
    const response = await fetch(`https://app.uwc.world/api/Auth/LoginByOTP`, {
      method: "POST",
      headers: otpHeaders,
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const postResponse = await response.json();

    const token = postResponse?.data;

    const value = jwtDecode(token);
    //setBearerToken(value.access_token);
    sessionStorage.setItem("token", value.access_token);
    return value.access_token;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const postAddSessionData = async (body, step) => {
  switch (step) {
    case 1:
      try {
        const response = await fetch(
          `https://us.uwc.world/new-uwc/session-notes/add`,
          {
            method: "POST",
            headers,
            body,
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const postResponse = await response.json();

        return postResponse.data;
      } catch (error) {
        console.error("Error:", error);
      }

      break;
    default:
      console.log("Something went wrong");
  }
};

export const fetchForms = async () => {
  try {
    const response = await fetch(
      "https://us.uwc.world/new-uwc/session-notes/get-forms",
      {
        method: "GET",
        headers,
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();
    //console.log("postResponse forms", postResponse)
    return postResponse.data;
    // Handle the response data
  } catch (error) {
    console.error(error);
    // Handle the error
  }
};

export const postClientScreenersData = async (userID, expertID) => {
  try {
    const screenerBody = {
      expert_id: userID,
      user_id: expertID,
      // user_id: currentUser?.UserId,
    };

    const response = await fetch(
      `https://odoo.unitedwecare.ca/new-uwc/expert/dashboard/assignments`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(screenerBody),
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();

    //const { assignments } = await postResponse.data;
    //const { worksheets } = await postResponse.data;

    return postResponse.data;

    // setClientScreeners(assignments);
    //setClientScreenersQNA(worksheets);
    //setUserData(postResponse?.data);

    //console.log("data", postResponse);
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

export const getSessionNotes = async (professionalID, clientID) => {
  const body = {
    professional_id: professionalID,
    client_id: clientID,
  };

  // console.log("body", body)
  try {
    const response = await fetch(
      `https://us.uwc.world/new-uwc/session-notes/get-notes`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();
    //console.log("postResponse", postResponse)

    return postResponse.data;
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

export const getSessionNotesById = async (professionalID, id) => {
  const body = {
    professional_id: `${professionalID}`, //1545,
    session_note_id: +id, //46
  };

  try {
    const response = await fetch(
      `https://us.uwc.world/new-uwc/session-notes/get-notes`,
      {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      }
    );
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();
    //console.log("postResponse", postResponse)

    return postResponse.data;
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

// getTranscript function has been moved to the appropriate component
// This keeps transcription logic centralized with components that use it

export const getTranslation = async (
  appointment_id,
  user_id,
  expert_id,
  appointment_date,
  booking_date,
  transcript
) => {
  const body = {
    target: "en-Us",
    text: transcript,
    session_id: `${appointment_id}`,
    appointment_id: `${appointment_id}`,
    user_id: `${user_id}`,
    expert_id: `${expert_id}`,
    appointment_date: `${appointment_date}`,
    booking_date: `${booking_date}`,
    speaker_id: `${expert_id}`,
  };

  try {
    const response = await fetch(`https://newtts.uwc.world/translate`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();
    console.log("getTranslation postResponse", postResponse);
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

export const OCRAppend = async ({ sessionData, ocrText }) => {
  const body = {
    // target: "en-Us",
    ocr_generated_text: ocrText,
    session_id: `${sessionData?.appointment_id}`,
    appointment_id: `${sessionData?.appointment_id}`,
    user_id: `${sessionData?.user_id}`,
    expert_id: `${sessionData?.expert_id}`,
    appointment_date: `${sessionData?.appointment_date}`,
    booking_date: `${sessionData?.booking_date}`,
    speaker_id: `${sessionData?.expert_id}`,
  };

  try {
    const response = await fetch(`https://ocr.uwc.world/ocr-append`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();
    console.log("getTranslation postResponse", postResponse);
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

export const OCRDocumentTranslation = async (
  // appointment_id,
  // user_id,
  // expert_id,
  // appointment_date,
  // booking_date,
  url
  // transcript
) => {
  const body = {
    // target: "en-Us",
    // session_id: `${appointment_id}`,
    // appointment_id: `${appointment_id}`,
    // user_id: `${user_id}`,
    // expert_id: `${expert_id}`,
    // appointment_date: `${appointment_date}`,
    // booking_date: `${booking_date}`,
    // speaker_id: `${expert_id}`,
    url: `${url}`,
  };

  try {
    const response = await fetch(`https://ocr.uwc.world/ocr-url`, {
      method: "POST",
      headers: {
        "X-API-Key": process.env.REACT_APP_EXPERT_API_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const postResponse = await response.json();
    console.log("getTranslation postResponse", postResponse);
  } catch (error) {
    console.error("Error:", error);
    return error;
  }
};

export const fetchSTTWhisper = async (data) => {
  try {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://s2t-v2.uwc.world/transcribe-v2",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Basic YWRtaW46WDlyJDN2ITJ3UXorOHBG",
      },
      data,
    };

    const resp = await axios.request(config);

    return resp?.data?.transcription;
  } catch (error) {
    console.error("Whisper API error", error);
  }
};

export const fetchSTTShunya = async (data) => {
  // Get API key from environment variable with fallback
  const SHUNYA_API_KEY = process.env.REACT_APP_SHUNYA_API_KEY || "FFc^5J+8PlFTceqg+Ss7cMSg@t5sY";
  
  // Using fallback API key if environment variable not set
  if (!process.env.REACT_APP_SHUNYA_API_KEY) {
    console.warn('REACT_APP_SHUNYA_API_KEY not found in environment variables, using fallback');
  }

  try {
    let cleanBase64;
    try {
      const parsedData = JSON.parse(data);
      cleanBase64 =
        parsedData.base64_audio || parsedData.audio_data_base64 || data;
    } catch (parseError) {
      cleanBase64 = data;
    }
    cleanBase64 = cleanBase64.replace(/^data:[^;]+;base64,/, "").trim();
    if (!cleanBase64) {
      throw new Error("Base64 string is empty after cleaning");
    }
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(cleanBase64)) {
      throw new Error("Base64 string contains invalid characters");
    }

    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "audio/wav" });
    const audioFile = new File([blob], "audio.wav", { type: "audio/wav" });
    const formData = new FormData();
    formData.append("audio", audioFile);
    formData.append("language_code", "auto");
    formData.append("enable_diarization", true);
    const response = await fetch("https://asr.shunyalabs.ai/transcribe", {
      method: "POST",
      headers: {
        "x-user-id": SHUNYA_API_KEY,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Shunya transcription failed: ${response.status}`);
    }

    const result = await response.json();
    
    // Extract transcription from various possible response field names
    const transcriptionText = result?.transcription || result?.text || result?.result || result?.transcript || result?.output;
    
    return transcriptionText || result;
  } catch (error) {
    console.error("Shunya API error:", error);
    throw error;
  }
};

export const fetchSTTShunyaSecond = async (data) => {
  // Get API key from environment variable with fallback
  const SHUNYA_TB_API_KEY = process.env.REACT_APP_SHUNYA_TB_API_KEY || "1FtoMG4hXDzDpkR7ZtXsSAqnf6rDQNxm";
  
  // Using fallback API key if environment variable not set
  // if (!process.env.REACT_APP_SHUNYA_TB_API_KEY) {
  //   console.warn('REACT_APP_SHUNYA_TB_API_KEY not found in environment variables, using fallback');
  // }

  try {
    let cleanBase64;
    try {
      const parsedData = JSON.parse(data);
      cleanBase64 =
        parsedData.base64_audio || parsedData.audio_data_base64 || data;
    } catch (parseError) {
      cleanBase64 = data;
    }
    cleanBase64 = cleanBase64.replace(/^data:[^;]+;base64,/, "").trim();
    if (!cleanBase64) {
      throw new Error("Base64 string is empty after cleaning");
    }
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(cleanBase64)) {
      throw new Error("Base64 string contains invalid characters");
    }

    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "audio/wav" });
    const audioFile = new File([blob], "your_audio.wav", { type: "audio/wav" });
    const formData = new FormData();
    formData.append("file", audioFile);
    formData.append("language_code", "med-en");
    
    const response = await fetch("https://tb.shunyalabs.ai/transcribe", {
      method: "POST",
      headers: {
        "X-API-Key": SHUNYA_TB_API_KEY,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Shunya TB transcription failed: ${response.status}`);
    }

    const result = await response.json();
    
    // Handle the response structure: { success: true, text: "...", detected_language: "...", total_time: ... }
    if (result?.success && result?.text) {
      return result.text;
    }
    
    // Fallback: Extract transcription from various possible response field names
    const transcriptionText = result?.transcription || result?.text || result?.result || result?.transcript || result?.output;
    
    return transcriptionText || result;
  } catch (error) {
    console.error("Shunya TB API error:", error);
    throw error;
  }
};

/*
   INCOMING DATA : JSON.stringify({base64_audio: formattedBase64})
*/
export const uploadFileToFirebase = async (data) => {
  try {
    // Parse the incoming stringified data
    let parsedData;
    try {
      parsedData = JSON.parse(data);
    } catch (parseError) {
      throw new Error("Invalid JSON data provided");
    }

    // Extract base64 data and filename
    const base64Data = parsedData.base64_audio || parsedData.base64_data || parsedData.data;
    const fileName = parsedData.filename || parsedData.name || `file_${Date.now()}.mp3`;
    const fileType = parsedData.fileType || parsedData.type || "audio/mpeg";

    if (!base64Data) {
      throw new Error("No base64 data found in the provided data");
    }

    // Clean the base64 string (remove data URL prefix if present)
    const cleanBase64 = base64Data.replace(/^data:[^;]+;base64,/, "").trim();
    
    if (!cleanBase64) {
      throw new Error("Base64 string is empty after cleaning");
    }

    // Validate base64 format
    if (!/^[A-Za-z0-9+/]*={0,2}$/.test(cleanBase64)) {
      throw new Error("Base64 string contains invalid characters");
    }

    // Convert base64 to binary data
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    
    // Create File object
    const file = new File([byteArray], fileName, { type: fileType });

    // Create Firebase storage reference
    const storageRef = ref(storage, `uploads/${fileName}`);
    
    // Upload file to Firebase Storage
    const uploadTask = uploadBytesResumable(storageRef, file);
    
    // Wait for upload to complete
    const snapshot = await uploadTask;
    
    // Get download URL
    const downloadURL = await getDownloadURL(snapshot.ref);

    try{
      // Note: Second API (fetchSTTShunyaSecond) has been implemented
      // See fetchSTTShunyaSecond function above for the second transcription API
      console.log("====================================")
      // 80% chance to use first API, 20% chance to use second API
      // const randomValue = Math.random();
      // const useSecondAPI = randomValue < 0.2; // 20% probability
      // console.log("useSecondAPI ::::: ", useSecondAPI);
      // if (useSecondAPI) {
      //   // Call the second Shunya API with base64 audio data
      //   const transcriptionText = await fetchSTTShunyaSecond(data);
        
      //   return {
      //     text: transcriptionText,
      //     link: downloadURL,
      //     apiUsed: "fetchSTTShunyaSecond" // Track which API was used
      //   };
      // } else {
        // Use the first API (cauth)
        const endpoint = "https://cauth.unitedwecare.com/transcriptions/transcribe-from-url";
        
        const response = await axios.post(endpoint, {
          url: downloadURL,
          language: parsedData.language
        }, {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_CAUTH_X_API_KEY
          }
        });

        if (response?.status !== 200) {
          return "Error transcribing file";
        }

        console.log("response ::::: just response", response);
        return {
          text: response?.data?.data?.text,
          link: downloadURL,
          apiUsed: "transcribe-from-url" // Track which API was used
        };
      // }

    }catch(error){
      console.error("Error uploading file to Firebase:", error);
      return {
        success: false,
        error: error.message
      };
    }
    
    // return {
    //   success: true,
    //   downloadURL: downloadURL,
    //   fileName: fileName,
    //   fileSize: file.size,
    //   fileType: fileType
    // };

  } catch (error) {
    console.error("Error uploading file to Firebase:", error);
    return {
      success: false,
      error: error.message
    };
  }
}; 